<template>
  <b-server-table
    :headers="[
      { title: 'Тип', key: 'entityType.name', sortable: false },
      ...orderListHeaders,
    ]"
    :request-func="getFamiliarizationList"
    :filter-props="{
      filterMap: [
        { key: 'search' },
        {
          key: 'departmentId',
          directory: 'departmentList',
          component: 'select',
        },
        {
          key: 'typeId',
          directory: 'orderTypes',
          component: 'select',
        },
        {
          key: 'directionId',
          directory: 'orderDirections',
          component: 'select',
        },
        {
          key: 'issuedUserId',
          directory: 'userList',
          component: 'autocomplete',
        },
        {
          key: 'fromDate',
          component: 'input-date',
        },
        {
          key: 'toDate',
          component: 'input-date',
        },
        {
          key: 'isActive',
          component: 'checkbox',
        },
      ],
    }"
    @click:row="navigate">
    <template #action-button>
      <div
        v-if="[USER_ROLE.ADMIN, USER_ROLE.CLERKSHIP].includes(user.roleId)"
        class="flex-grow-1 d-flex justify-end">
        <v-btn rounded="lg" @click.stop="familiarizationReportDialog">
          <v-icon class="mr-1" style="color: #fff"
            >{{ 'mdi-cloud-print-outline' }}
          </v-icon>
          Сформувати звіт
        </v-btn>
      </div>
    </template>
    <template #item.issuedUser="{ item }">
      <span v-if="item.issuedUser">
        {{ getPersonName(item.issuedUser) }}
      </span>
      <span v-else class="text-disabled">Не вказано</span>
    </template>
    <template #item.isActive="{ item }">
      <span>{{ item.isActive ? 'Активний' : 'Неактивний' }}</span>
    </template>
    <template #item.name="{ item }">
      <v-tooltip :text="item.name" bottom>
        <template #activator="{ props }">
          <span
            style="
              display: block;
              width: 350px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            v-bind="props">
            {{ item.name }}
          </span>
        </template>
      </v-tooltip>
    </template>
    <template #bottom></template>
  </b-server-table>
</template>

<script lang="ts">
import { axios, useBreadcrumb } from '@/plugins/index.js'
import { computed } from 'vue'
import { navigateToItem } from '@/utils/helpers.js'
import { urlFamiliarizationList } from '@/utils/urls.js'
import { openDialog } from '@/dialog'
import { useStore } from 'vuex'
import { BServerTable } from 'best-modules/components'
import { getPersonName } from 'best-modules/utils'
import { orderListHeaders } from '@/utils/tableHeaders'
import { useRoute } from 'vue-router'
import { USER_ROLE } from '@/utils/constants'

export default {
  components: { BServerTable },
  data: () => ({
    USER_ROLE,
    orderListHeaders,
  }),
  methods: { getPersonName },
  setup() {
    const route = useRoute()
    const store = useStore()
    const breadcrumb = useBreadcrumb()
    breadcrumb.set([], { type: 'replace' })

    const user = computed(() => store.state.user.userData || {})

    const navigate = (event: any) => {
      navigateToItem('single-order', event.id)
    }

    const getFamiliarizationList = (query: any) => {
      const isAcceptedAcknowledgment =
        route.name === 'familiarization-list-done'
      return axios
        .get(
          urlFamiliarizationList({ isAcceptedAcknowledgment, ...(query || {}) })
        )
        .then(res => res.data)
    }

    const familiarizationReportDialog = () => {
      openDialog({
        name: 'FamiliarizationReport',
        action: 'create',
      })
    }

    return {
      getFamiliarizationList,
      navigateToItem,
      familiarizationReportDialog,
      navigate,
      user,
    }
  },
}
</script>

<style lang="scss" scoped></style>
